import { defineMessages } from 'react-intl';

export default defineMessages({
    noPolicyNotes: {
        id: 'gateway.views.activity-summary.No notes associated with this policy',
        defaultMessage: 'There are no notes associated with this policy.',
    },
    errorLoadingNotes: {
        id: 'gateway.views.policy-detail.notes.error',
        defaultMessage:
            'Could not retrieve notes for Policy Number: {policyNumber}',
    },
    errorCreatingNotes: {
        id: 'gateway.views.policy-detail.notes.Failed to create note',
        defaultMessage: 'Failed to create note',
    },
});
